import type { PoolGroup } from '../api/types';
import { PoolRow } from './PoolRow';

interface PoolTableProps {
  poolGroups: PoolGroup[];
}

export function PoolTable({ poolGroups }: PoolTableProps) {
  return (
    <div className="pool-table-container">
      {poolGroups.map((group) => (
        <div key={group.type} className="pool-group">
          <h2 className="group-title">
            {group.type === 'slipstream' ? 'Slipstream Pools' : 'Basic Pools'}
          </h2>
          <div className="table-wrapper">
            <table className="pool-table">
              <thead>
                <tr>
                  <th>Pool Name</th>
                  <th>Pool Type</th>
                  <th>TVL</th>
                  <th className="current-apr-header">Current APR</th>
                  <th>1h APR</th>
                  <th>4h APR</th>
                  <th>12h APR</th>
                  <th>24h APR</th>
                  <th>7d APR</th>
                  <th>1mo APR</th>
                  <th>6mo APR</th>
                  <th>1yr APR</th>
                </tr>
              </thead>
              <tbody>
                {group.pools.map((pool) => (
                  <PoolRow key={pool.poolAddress} pool={pool} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
